export var WebSocketEvents;
(function (WebSocketEvents) {
    WebSocketEvents["ORDER_PAYMENT_VERIFYING"] = "ORDER_PAYMENT_VERIFYING";
    WebSocketEvents["ORDER_PROCESSING"] = "ORDER_PROCESSING";
    WebSocketEvents["ORDER_COMPLETED"] = "ORDER_COMPLETED";
    WebSocketEvents["ORDER_FAILED"] = "ORDER_FAILED";
})(WebSocketEvents || (WebSocketEvents = {}));
export var TransakOrderStatus;
(function (TransakOrderStatus) {
    TransakOrderStatus["AWAITING_PAYMENT_FROM_USER"] = "AWAITING_PAYMENT_FROM_USER";
    TransakOrderStatus["PAYMENT_DONE_MARKED_BY_USER"] = "PAYMENT_DONE_MARKED_BY_USER";
    TransakOrderStatus["PROCESSING"] = "PROCESSING";
    TransakOrderStatus["PENDING_DELIVERY_FROM_TRANSAK"] = "PENDING_DELIVERY_FROM_TRANSAK";
    TransakOrderStatus["ON_HOLD_PENDING_DELIVERY_FROM_TRANSAK"] = "ON_HOLD_PENDING_DELIVERY_FROM_TRANSAK";
    TransakOrderStatus["COMPLETED"] = "COMPLETED";
    TransakOrderStatus["CANCELLED"] = "CANCELLED";
    TransakOrderStatus["FAILED"] = "FAILED";
    TransakOrderStatus["REFUNDED"] = "REFUNDED";
    TransakOrderStatus["EXPIRED"] = "EXPIRED";
})(TransakOrderStatus || (TransakOrderStatus = {}));
export var TradeType;
(function (TradeType) {
    TradeType["PRIMARY"] = "primary";
    TradeType["SECONDARY"] = "secondary";
})(TradeType || (TradeType = {}));
export var ProductsAvailed;
(function (ProductsAvailed) {
    ProductsAvailed["BUY"] = "BUY";
})(ProductsAvailed || (ProductsAvailed = {}));
//# sourceMappingURL=types.js.map